import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobComment } from "@/types";

/**
 * This hook is used to add a new job comment to the job comments query
 * without refetching the entire query.
 */
export const useAddJobComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobCommentToAdd }: { jobCommentToAdd: JobComment }) => {
    queryClient.setQueryData(
      ["job-comments", currentCompanyId, currentJobId],
      (cachedData: JobComment[]) => {
        // Important to add the new job comment to the top of the list.
        return [jobCommentToAdd, ...cachedData];
      },
    );
  };
};
